import Model from "src/models/base/model.js";

class FintechSetting extends Model{
  resourceName() {
    return "fintech_settings";
  }

  fields() {
    return {
      documents: "",
      modalities: "",
      fintech_id: "",
    };
  }
}

export default new FintechSetting();
